export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M7.892 5.813a.75.75 0 0 1 1.06 1.06L3.826 12l5.126 5.126a.75.75 0 0 1-1.06 1.06l-5.657-5.655-.052-.058a.75.75 0 0 1 .052-1.003l5.657-5.657Zm7.156 0a.75.75 0 0 1 1.06 0l5.657 5.657.052.057a.75.75 0 0 1-.052 1.004l-5.656 5.656a.75.75 0 1 1-1.06-1.06L20.173 12l-5.126-5.127a.75.75 0 0 1 0-1.06Z"/>
</svg>
`;
